import { gql } from "@apollo/client";

export const CREATE_STUDENT = gql`
mutation createStudent($input:createStudentInput!) {
  addStudent(input: $input) {
    message
  }
}
`;

export const VERIFY_CLASS_CODE_STUDENT = gql`
query verifyClassroomCodeForStudent($cCode: String!) {
  verifyClassCodeForStudentV2(cCode: $cCode) {
    cId
  }
}
`;

export const GET_VIRTUAL_SCHOOL_CLASSCODES_LIST = gql`
query getClassroomForVirtualClass {
  getAClassCodeForVirtualClass {
    cId
    cName
    cOriginalName
    cCode
  }
}`;

export const CREATE_PTA = gql`
mutation addPta($input: createPtaInput!) {
  addPta(input: $input)
}
`;

export const FORGOT_PASSWORD_STUDENT = gql`
mutation sendForgotPasswordMail($input: forgotMailInput!) {
  sendForgotPasswordMail(input: $input)
}
`;
export const UPDATE_APP_VERSION = gql`
mutation updateUserAppVersion($versionData: JSON) {
  updateUserAppVersion(input: {versionData: $versionData})
}
`;

export const GET_VIRTUAL_CLASS_LEVELS = gql`
query allClassrooms{
  allClassrooms(
    filter: {schoolAdminBySaId: {adminType: {equalTo: VIRTUAL}}, deletedAt: {isNull: true}}
  ) {
    nodes {
      cId
      cName
      cOriginalName
    }
    totalCount
  }
}
`;


// VIRTUAL SCHOOL
export const VERIFY_EXISTING_STUDENT = gql`
mutation VerifyExistingStudent($input: verifyExistingStudentInput!) {
  verifyExistingStudent(input: $input) {
    verified
    userName
    fullName
    email
    phoneNumber
    alreadyInVirtualClassroom
    message
  }
}
`;

export const GET_REGISTRATION_OPTIONS = gql`
query RegistrationOptions {
  registrationOptions {
    genders
    guardianRelationships
    academicLevels
    networkProviders
    locations
    communicationGroups
    referralSources
    dataOptInTargets
  }
}
`;

export const GET_PROGRAMME_CATALOGUE = gql`
query ProgrammeCatalogue {
  programmeCatalogue {
    programmeId
    code
    name
    description
    price
    currency
    startDate
    endDate
    duration
    subjects {
      sjId
      subjectName
      subjectAvatarUrl
      colorCode
    }
  }
}
`;

export const REGISTER_STUDENT_FOR_PROGRAMME = gql`
mutation RegisterStudent($input: registerStudentInput!) {
  registerStudentForProgramme(input: $input) {
    registrationId
    programmeName
    programmeCode
    userName
    isExistingUser
    paymentLink
    paymentReference
    amount
    currency
    message
    tokens {
      AccessToken
      RefreshToken
      IdToken
    }
  }
}
`;

export const RESUME_PAYMENT = gql`
mutation ResumePayment($isPaidCheck: Boolean = false) {
  resumeVirtualSchoolPayment(isPaidCheck: $isPaidCheck) {
    hasRegistration
    paid
    registrationId
    programmeName
    amount
    currency
    paymentLink
    iframeLink
    message
    pendingStatus
    originalStatus
  }
}
`;


